import styled from "styled-components";

export const Text = styled.div`
@media (max-width: 400px) {
    a {
        color: #768A46 !important;
    }
}
`